import $ from "jquery";
import WOW from "wowjs";
import "parsleyjs";
import "selectric";
import intlTelInput from "intl-tel-input/build/js/intlTelInput-jquery.min";
import "intl-tel-input/build/js/utils";
import { isFunction } from "@/scripts/helpers/is";
import { disableElement } from "@/scripts/helpers/elementsActions";
import { CLASSES } from "@/scripts/helpers/constants";
import { dropLast } from "ramda";
import { STRINGS } from "@/scripts/helpers/constants";

export const initWowLibrary = () => {
  window.wow = new WOW.WOW({
    live: false
  });
  window.wow.init();
};

// $.fn.inView = function() {
//   const win = $(window);
//   const obj = $(this);
//   const scrollPosition = win.scrollTop();
//   const visibleArea = win.scrollTop() + win.height();
//   const objEndPos = obj.offset().top;
//
//   return visibleArea >= objEndPos && scrollPosition <= objEndPos;
// };

export const clearFocusedElements = () => {
  $(":focus").blur();
};

export const initLoader = selector => {
  // Possible to have several loaders
  // If no selector passed on, find closest and use it globally
  const loader = selector || $("." + CLASSES.LOADER);
  const loaderWrapper = loader.closest("." + CLASSES.LOADER_WRAPPER);
  const layout = $(".layout");

  if (loader.length && layout.length) {
    if (!loaderWrapper.length) {
      layout.addClass(CLASSES.LOADER_WRAPPER);
    }
    loader.addClass(CLASSES.IS_ACTIVE);
  }
};

export const hideLoader = () => {
  const loader = $("." + CLASSES.LOADER);
  const layout = $(".layout");

  if (loader.length && loader.hasClass(CLASSES.IS_ACTIVE)) {
    loader.removeClass(CLASSES.IS_ACTIVE);
  }

  if (layout.length && layout.hasClass(CLASSES.LOADER_WRAPPER)) {
    layout.removeClass(CLASSES.LOADER_WRAPPER);
  }
};

export const attachJQueryPlugins = function() {
  if ($) {
    $.fn.inView = function() {
      const win = $(window);
      const obj = $(this);
      const scrollPosition = win.scrollTop();
      const visibleArea = win.scrollTop() + win.height();
      const objEndPos = obj.offset().top;

      return visibleArea >= objEndPos && scrollPosition <= objEndPos;
    };
  }
};

export const bindJQuery = function() {
  window.$ = window.JQuery = $;

  attachJQueryPlugins();
};

export const attachIE11helper = () => {
  if (!!navigator.userAgent.match(/Trident.*rv[ :]*11\./)) $("body").addClass("is-ie11");
};

export const attachEdgeBrowserHelper = () => {
  if (/Edge/.test(navigator.userAgent)) $("body").addClass("is-edge");
};

export const attachFirefoxBrowser = () => {
  if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1)
    $("body").addClass("is-firefox");
};

export const attachSafariBrowser = () => {
  if (
    navigator.userAgent.search("Safari") >= 0 &&
    navigator.userAgent.search("Chrome") < 0
  )
    $("body").addClass("is-safari");
};

export const classes = {
  formInput: ".form-control",
  formSubmit: ".form-submit",
  formInner: ".form__inner",
  successStatus: "status-action-success",
  failedStatus: "status-action-failed",
  ctaStyled: "call-to-action-styled"
};

// Forms functionality
const addParsleyFieldAttrs = form => {
  const email = form.find('input[type="email"]');
  // TODO cache strings to CONSTANTS
  if (email.length) {
    if (!email.data("parsleyType")) {
      email.attr("data-parsley-type", "email");
    }
    if (!email.data("parsleyRequiredMessage")) {
      email.attr("data-parsley-required-message", STRINGS.EMAIL_VALIDATION_MESSAGE);
    }
  }
};

const hideErrorByEvent = event => {
  $(classes.formInput).on(event, function() {
    const input = $(this);
    input.parsley().reset();
  });
};

export const handleParsleyActions = form => {
  // TODO discuss default input messages (to avoid adding field attrs in Pug)
  const forms = $("form");

  if (forms.length) {
    forms.each(function() {
      const form = $(this);

      form.attr("data-parsley-focus", "none");
      addParsleyFieldAttrs(form);

      form
        .parsley({
          requiredMessage: "This field is required"
        })
        .on("field:error", function() {
          const field = this.$element;
          const selectWrapperClass = ".selectric-wrapper";
          if (field.is("select")) {
            const selectWrapper = field.parents(selectWrapperClass);

            if (selectWrapper.length) selectWrapper.addClass("has-error");
          }
        });
    });
  }
  hideErrorByEvent("focus");
};

export const handleFormActions = (
  formId,
  successCallback,
  validateCustomInputs
) => {
  const form = $("#" + formId);
  const formSubmit = form.find(classes.formSubmit);
  let customInputsValid = null;

  if (form.length) {
    form
      .parsley()
      .on("form:validate", function() {
        if (isFunction(validateCustomInputs))
          customInputsValid = validateCustomInputs.call();
      })
      .on("form:error", function() {
        if (isFunction(validateCustomInputs) && !customInputsValid) {
          const formOffset = form.offset().top - 20;

          if (!form.inView()) window.scrollTo({ top: formOffset, behavior: "smooth" });

          return false;
        } else {
          const control = $(".parsley-error:first");
          const label = control
            .parent()
            .parent()
            .find(".form-label");
          const labelHeight = label.height() + 10;
          const controlTopOffset = control.offset().top - labelHeight;

          if (control.length && label.length && !label.inView()) {
            window.scrollTo({ top: controlTopOffset, behavior: "smooth" });
          }
        }
      })
      .on("form:submit", function() {
        if (isFunction(validateCustomInputs) && !customInputsValid)
          return false;

        disableElement(formSubmit);

        if (isFunction(successCallback)) {
          successCallback.call();
          return false;
        }
      });
  }
};

export const resetForm = element => {
  // TODO create func restFormToState (form can be not always empty by default)
  if (element.length) {
    const inputs = element.find(classes.formInput);

    inputs.each(function() {
      $(this).val("");
    });
  }
};

const closeITIDropdown = () => {
  // TODO: hotfix - think about another way
  const phoneInput = document.getElementById("phone-number-input");
  if (phoneInput !== null) phoneInput.click();
};

const changeSelectLabelStyle = () => {
  const $label = document.querySelectorAll(".selectric");
  $label.forEach(el => {
    el.addEventListener("DOMSubtreeModified", function() {
      $(this).addClass("selectric-label-selected");
    });
  })
};

export const initCustomSelectPlugin = () => {
  const hideCustomSelectError = event => {
    const select = $(event);

    if (select.length && select.hasClass("parsley-error")) {
      const selectWrapper = select.parents(".selectric-wrapper.has-error");

      if (selectWrapper.length) selectWrapper.removeClass("has-error");
      select.parsley().reset();
    }
  };

  $("select").selectric({
    onOpen: function(e) {
      hideCustomSelectError(e);
      closeITIDropdown();
    },
    onChange: hideCustomSelectError
  });

  changeSelectLabelStyle();
};

export const initIntlTelInputPlugin = () => {
  const $phoneInput = $("#phone-number-input");

  if ($phoneInput.length) {
    const iti = $phoneInput.intlTelInput({
      separateDialCode: true,
    });

    $phoneInput.on("keyup countrychange", function() {
      $phoneInput.attr("value", iti.intlTelInput("getNumber"));
    });
  }
};

export const isMobileDevice = () => {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

export const loadScript = (
  url,
  implementationCode,
  location = document.body
) => {
  const scriptTag = document.createElement("script");
  scriptTag.src = url;
  scriptTag.onload = implementationCode;
  scriptTag.onreadystatechange = implementationCode;

  location.appendChild(scriptTag);
};

export const getFirstWord = string => {
  return string.replace(/ .*/, "");
};

export const capitalize = string => {
  if (typeof string !== "string") return "";

  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const toKebabCase = str =>
  str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map(x => x.toLowerCase())
    .join("-");

export const createChangedValueChecker = () => {
  let prevValue;

  return value => {
    const result = value !== prevValue;

    prevValue = value;

    return result;
  };
};

export const cropLastLetter = (s = "") => {
  return dropLast(1, s);
};

// Function from David Walsh: http://davidwalsh.name/css-animation-callback
/*
  Wait until the css animation ends
 */
function whichTransitionEvent() {
  let t,
      el = document.createElement("fakeelement");

  let animations = {
    "animation"      : "animationend",
    "OAnimation"     : "oAnimationEnd",
    "MozAnimation"   : "animationend",
    "WebkitAnimation": "webkitAnimationEnd"
  };

  for (t in animations) {
    if (el.style[t] !== undefined){
      return animations[t];
    }
  }
}
export const transitionEvent = whichTransitionEvent();